import React, { type FC } from 'react'
import { Grid, type SxProps, type Theme, Typography } from '@mui/material'

import { Translation } from '../../../../domain'

import { FormattedTranslation } from '../../Internationalization'

const headerStyle: SxProps<Theme> = { pt: 1, pb: 2 }

export const Header: FC = () => {
    return (
        <Grid sx={headerStyle} container>
            <Grid size={{ xs: 2 }}>
                <Typography variant="body1">
                    <FormattedTranslation id={Translation.TIME} />
                </Typography>
            </Grid>
            <Grid size={{ xs: 5 }}>
                <Typography variant="body1">
                    <FormattedTranslation id={Translation.TOPIC} values={{ count: 1 }} />
                </Typography>
            </Grid>
            <Grid size={{ xs: 4 }}>
                <Typography variant="body1">
                    <FormattedTranslation id={Translation.DATA} />
                </Typography>
            </Grid>
            <Grid size={{ xs: 1 }}>
                <Typography variant="body1">
                    <FormattedTranslation id={Translation.TYPE} />
                </Typography>
            </Grid>
        </Grid>
    )
}
